import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-67dd4c88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "modal__title" }, "Создание номенклатуры", -1))
const _hoisted_4 = { class: "modal__field narrow" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Артикул*", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Габариты, см*", -1))
const _hoisted_7 = { class: "modal__size-wrapp narrow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Ш:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "В:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Г:", -1))
const _hoisted_11 = { class: "modal__field narrow" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Штрихкод", -1))
const _hoisted_13 = { class: "modal__field narrow" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Вес, кг*", -1))
const _hoisted_15 = { class: "modal__field narrow" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Количество слоёв", -1))
const _hoisted_17 = { class: "modal__field narrow" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Количество в слое", -1))
const _hoisted_19 = { class: "modal__field narrow modal__field--fragility" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "modal__label" }, "Хрупкость*", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__fragility--text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "gray-btn" }, "Менее хрупкий"),
  /*#__PURE__*/_createElementVNode("span", { class: "gray-btn" }, "Более хрупкий")
], -1))
const _hoisted_22 = { class: "modal__field" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconClose = _resolveComponent("iconClose")!
  const _component_QInput = _resolveComponent("QInput")!
  const _component_q_slider = _resolveComponent("q-slider")!
  const _component_QCard = _resolveComponent("QCard")!
  const _component_QDialog = _resolveComponent("QDialog")!

  return (_openBlock(), _createBlock(_component_QDialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isOpen) = $event)),
    onHide: _ctx.afterLeave
  }, {
    default: _withCtx(() => [
      _createVNode(_component_QCard, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_iconClose, {
                class: "link gray-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.article,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.data.article) = $event)),
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.width,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.data.width) = $event)),
                type: "number",
                min: "0",
                class: "modal__size-input"
              }, null, 8, ["modelValue"]),
              _hoisted_9,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.height,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.data.height) = $event)),
                type: "number",
                min: "0",
                class: "modal__size-input"
              }, null, 8, ["modelValue"]),
              _hoisted_10,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.depth,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.data.depth) = $event)),
                type: "number",
                min: "0",
                class: "modal__size-input"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.barcode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.data.barcode) = $event)),
                type: "text"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.weight,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.data.weight) = $event)),
                type: "number",
                min: "0"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.max_layer_height,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.data.max_layer_height) = $event)),
                type: "number",
                min: "0"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_QInput, {
                outlined: "",
                modelValue: _ctx.form.data.max_in_layer,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.data.max_in_layer) = $event)),
                type: "number",
                min: "0"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _hoisted_21,
              _createVNode(_component_q_slider, {
                modelValue: _ctx.selectedOption,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedOption) = $event)),
                "marker-labels": 
              _ctx.fragilityOptions.map((option) => option.label.toString())
            ,
                min: 0,
                max: 5
              }, null, 8, ["modelValue", "marker-labels"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submit())),
                  disabled: _ctx.isSubmitDisabled || _ctx.state.preloader
                }, " Сохранить ", 8, _hoisted_24)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onHide"]))
}